import { isTrialTariff, PAYMENT_PRODUCTS, PRODUCT_KEYS } from '@focuslee/shared';
export interface PremiumUser {
    id: string;
    role: string;
    tariff?: string | null;
    subscriptionExpiresAt?: number | null;
    subscription?: {
        id: string;
        subscriptionCanceledAt?: string | null;
        subscriptionExpiresAt?: number | null;
    } | null;
}

export function getPremiumState(user: PremiumUser) {
    const isAdmin = user.role === 'Admin';
    const isTrialActive =
        (isAdmin || user.role === 'Premium') && isTrialTariff(user.tariff) && (user.subscriptionExpiresAt ?? 0) > Date.now() / 1000;
    const isManualPremium =
        !isTrialTariff(user.tariff) &&
        (isAdmin || user.role === 'Premium') &&
        (!user.subscription || user.tariff === 'manual') &&
        ((user.subscriptionExpiresAt ?? 0) > Date.now() / 1000 || (user.role === 'Premium' && user.subscriptionExpiresAt == null));
    const isSubscriptionActive = Boolean(user.subscription) && !isManualPremium;
    const hasPremium = isAdmin || isTrialActive || isManualPremium || isSubscriptionActive;
    const hasUsedTrial = Boolean(user.tariff);
    const productKey = isAdmin ? PRODUCT_KEYS.premiumMonthlyAdmin : PRODUCT_KEYS.premiumMonthly;

    return {
        isAdmin,
        isTrialActive,
        isManualPremium,
        isSubscriptionActive,
        hasPremium,
        hasUsedTrial,
        canSubscribe: !hasPremium || (isAdmin && !isManualPremium && !isSubscriptionActive),
        shouldStartTrial: !isAdmin && !hasUsedTrial,
        canStartAdminTrial: isAdmin && !hasUsedTrial && !user.subscription && !isManualPremium,
        productKey,
        product: PAYMENT_PRODUCTS[productKey],
        expiresAt: isManualPremium ? user.subscriptionExpiresAt : user.subscription?.subscriptionExpiresAt ?? user.subscriptionExpiresAt,
    };
}
